/**
 * Every area's routes and nav entries, in display order. An area adds a
 * screen in its own file beside this one; main.tsx and the layout read from
 * here and don't change.
 */

import { billing } from "./billing";
import { campaigns } from "./campaigns";
import { stores } from "./stores";
import type { AppRoute, NavEntry } from "./types";

const areas = [stores, campaigns, billing];

export const ROUTES: AppRoute[] = areas.flatMap((a) => a.routes);
export const NAV: NavEntry[] = areas.flatMap((a) => a.nav);

export type { AppRoute, NavEntry, AreaRoutes } from "./types";
